import { useForm } from "react-hook-form";
import { validateMaxlength } from "../../../../utils/validate";

const NewsSearchForm = ({ setSearchCondition, setTableData }) => {
  // 検索フォーム用
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  // 検索ボタン
  const onSubmit = async (data) => {
    setSearchCondition(data);
  };

  const resetCondition = () => {
    setValue("keyword", "");
    setValue("date_from", "");
    setValue("date_to", "");
  };

  return (
    <div className="p-page-search">
      <form className="p-page-form" onSubmit={handleSubmit(onSubmit)}>
        <label htmlFor="keyword">キーワード検索</label>
        <input
          type="text"
          name="keyword"
          id="keyword"
          maxLength="100"
          placeholder="キーワードを入力してください"
          {...register("keyword", {
            ...validateMaxlength(100),
          })}
        />
        <label htmlFor="date_from">日付から検索</label>
        <div>
          <div className="p-page-form__date">
            <input
              type="date"
              name="date_from"
              className={`form-control ${
                errors["date_from"] ? "is-invalid" : ""
              }`}
              {...register("date_from", { ...validateMaxlength(10) })}
            />
            <p>から</p>
            <input
              type="date"
              name="date_to"
              className={`form-control ${
                errors["date_to"] ? "is-invalid" : ""
              }`}
              {...register("date_to", { ...validateMaxlength(10) })}
            />
          </div>
          <div className="p-login-con__err-txt">
            {errors["date_from"]
              ? "日付(開始)に" + errors["date_from"].message
              : ""}
            {errors["date_to"] ? (
              <>
                <br />
                {"日付(終了)に" + errors["date_to"].message}
              </>
            ) : (
              ""
            )}
          </div>
        </div>
        <input className="p-page-form__btn" type="submit" value="検索する" />
        <input
          className="p-page-form__reset"
          type="reset"
          name="reset"
          value="条件をクリア"
          onClick={() => resetCondition()}
        />
      </form>
    </div>
  );
};

export default NewsSearchForm;
